module.exports = "<div class=\"row pt-4\">\n  <div class=\"col-md-12 col-lg-12\">\n    <app-task-report></app-task-report>\n  </div>\n</div>\n"